import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OuiButtonModule } from 'omnium-ui/button';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiMenuModule } from 'omnium-ui/menu';
import { MenuNode } from 'omnium-ui/shared';

@Component({
    selector: 'lib-document-viewer-header',
    imports: [CommonModule, OuiButtonModule, OuiIconModule, OuiMenuModule],
    templateUrl: './document-viewer-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./document-viewer-header.component.scss']
})
export class DocumentViewerHeaderComponent {
  @Input({ required: true })
  documentName: string;

  @Input()
  fileName?: string;

  @Input()
  dateAjout?: Date;

  @Input()
  menu?: MenuNode[];

  @Input()
  showCloseButton: boolean = true;

  @Output()
  close = new EventEmitter();
}
